import { render } from "./ElipsiIcon.vue?vue&type=template&id=1bb23922"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/ElipsiIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bb23922"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bb23922', __exports__)) {
    api.reload('1bb23922', __exports__)
  }
  
  module.hot.accept("./ElipsiIcon.vue?vue&type=template&id=1bb23922", () => {
    api.rerender('1bb23922', render)
  })

}


export default __exports__